import React from 'react';
import { COLORS } from '../../constants';

const LoadingState = () => {
  const LoadingSpinner = () => (
    <svg 
      width="50" 
      height="50" 
      viewBox="0 0 50 50"
      style={{
        animation: 'spin 1s linear infinite'
      }}
    >
      <circle
        cx="25"
        cy="25"
        r="20"
        fill="none"
        stroke={COLORS.primary}
        strokeWidth="4"
        strokeDasharray="31.415, 31.415"
        strokeLinecap="round"
      />
    </svg>
  );

  return (
    <div style={styles.container}>
      <style>
        {`
          @keyframes spin {
            0% { transform: rotate(0deg); }
            100% { transform: rotate(360deg); }
          }
        `}
      </style>
      <LoadingSpinner />
      <div style={styles.text}>Loading your profile...</div>
      <div style={styles.subtext}>Please wait while we fetch your information</div>
    </div>
  );
};

const styles = {
  container: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    justifyContent: 'center',
    minHeight: '100vh',
    background: `linear-gradient(135deg, ${COLORS.background} 0%, #fdf5f6 100%)`
  },
  text: {
    marginTop: 20,
    fontSize: 20,
    fontWeight: 600,
    color: COLORS.primary
  },
  subtext: {
    marginTop: 8,
    fontSize: 14,
    color: COLORS.darkGray
  }
};

export default LoadingState;